import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

const OneLineSkeleton = (props) => {
  const { width, height } = props;
  return (
    <ContentLoader viewBox="0 0 300 50">
      <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
  );
};

export default OneLineSkeleton;

OneLineSkeleton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

OneLineSkeleton.defaultProps = {
  width: 100,
  height: 15,
};
